import { Injectable } from '@angular/core';
import { URLSearchParams, Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { HttpService } from './http-service';
import 'rxjs/add/operator/map';
import { LoadingService } from "./loading-service";
import { AuthStore } from '../stores/auth-store';

/*
  Generated class for the HttpRegistProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HttpRegistProvider extends HttpService {

  constructor(protected http: Http, protected loadingService: LoadingService, protected authStore: AuthStore) {
    super(http, loadingService, authStore);
  }

  /**
   * 電話番号認証リクエストURLを取得する
   */
  getSmsLink(phoneNumber: string): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/regist/getSmsLink");
    var options = super.buildParam(userParam);

    return super.post(options, { phoneNumber: phoneNumber });
  }
}


// WEBPACK FOOTER //
// ./src/providers/http-regist.ts